import { createSlice } from '@reduxjs/toolkit';
import { getTotalDepositWithDriver } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const totalDepositWithDriver = createSlice({
  name: 'totalDepositWithDriver',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTotalDepositWithDriver.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getTotalDepositWithDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getTotalDepositWithDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.data = action.payload;
      });
  },
});

export default totalDepositWithDriver.reducer;
